import { useState } from 'react';
import { SelectNetwork } from '@ewf/components/Lifting/SelectNetwork';
import { AddressBook } from '@ewf/components/AddressBook';
import { ModalContainer } from '@ewf/components/ModalUI/ModalContainer';
import { LIFTING_CHAINS, MARKETPLACE_CHAINS } from '@shared/types/enums';

type Step = 'select-network' | 'address-book';

export const AddAccountFlow = ({ isOpen, onClose }: Props): JSX.Element | null => {
  const [step, setStep] = useState<Step>('select-network');
  const [selectedNetwork, setSelectedNetwork] = useState<LIFTING_CHAINS>(MARKETPLACE_CHAINS.ETH);

  const handleNetworkSelection = (network: LIFTING_CHAINS) => {
    setSelectedNetwork(network);
    setStep('address-book');
  };

  const handleClose = () => {
    setStep('select-network');
    setSelectedNetwork(MARKETPLACE_CHAINS.ETH);
    onClose();
  };

  const handleGoBack = () => {
    setStep('select-network');
  };

  if (!isOpen) return null;

  const stepComponents: Record<Step, JSX.Element> = {
    'select-network': (
      <SelectNetwork
        defaultNetwork={selectedNetwork}
        onNext={handleNetworkSelection}
        onClose={handleClose}
      />
    ),
    'address-book': (
      <ModalContainer>
        <AddressBook network={selectedNetwork} onClose={handleClose} onGoBack={handleGoBack} />
      </ModalContainer>
    ),
  };

  return stepComponents[step];
};

interface Props {
  isOpen: boolean;
  onClose: () => void;
}
